// ─────────────────────────────────────────────────────────────────────────────
//  intendedPlan — bridges the pre-signup tier picker with the post-signup
//  paywall trigger. We persist in `sessionStorage` (NOT localStorage) so the
//  intent dies with the tab — if a user closes the app mid-signup, they're
//  not haunted by a sticky paywall on a future visit.
//
//  Shape: { tier_key: "spark", source: "plan_select", at: <ISO timestamp> }
// ─────────────────────────────────────────────────────────────────────────────

const KEY = "kinly.intended_plan";

export function setIntendedPlan(tierKey, source = "plan_select") {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({
      tier_key: tierKey,
      source,
      at: new Date().toISOString(),
    }));
  } catch { /* private mode etc. — safe to ignore */ }
}

export function getIntendedPlan() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearIntendedPlan() {
  try { sessionStorage.removeItem(KEY); } catch { /* no-op */ }
}
